window.addEventListener(
  "DOMContentLoaded",
  function () {
    function setRem() {
      document.documentElement.style.fontSize =
        document.documentElement.clientWidth / 10 + "px";
    }
    setRem();
    window.addEventListener("resize", setRem);
  },
  false
);

